// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "common" + "." + "5a5fd6cb" + ".js";
};